export const ru = {
    'ads-description': {
        one: 'Выбрано {count} объявление',
        some: 'Выбрано {count} объявления',
        many: 'Выбрано {count} объявлений',
        none: 'Выбрано {count} объявлений'
    },
    'button-accept': 'Заменить',
    'button-cancel': 'Отмена',
    'change-parameter': 'Заменить параметр',
    'change-placeholder': 'Пустое поле удалит параметр',
    'change-placeholder-value': 'Пустое поле удалит значение',
    'change-title': 'Заменить на',
    'change-value': 'Заменить значение',
    'edit-site-links': 'Исправлять быстрые ссылки',
    'target-parameters-placeholder': 'Ищем только по точному совпадению',
    'target-parameters-title': 'Найти',
    'text-info':
        'Вы можете менять названия или значения параметров, основная ссылка при этом не будет заменена. Поиск происходит только по точному совпадению.',
    title: 'Заменить трекинговые параметры'
};
